import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer-section footer-two bg-gray text-white rel z-1">
      <div className="container">
        <div className="call-to-action bg-blue bgs-cover text-white rel z-1">
          <div className="row align-items-center">
            <div className="col-xl-7 col-lg-6">
              <div className="section-title mb-20">
                <h2>Have Any Help to CRM Solutions?</h2>
                <p>Professional service for your Customer Relationship Management</p>
              </div>
            </div>
            <div className="col-xl-5 col-lg-6">
              <div className="call-to-action-btns text-xl-right mb-20">
                <Link to="/contact" className="theme-btn style-two rmb-15">
                  Get Started <i className="fas fa-arrow-right"></i>
                </Link>
                <br />
                <br />
                <Link to="/contact" className="theme-btn style-three rmb-15">
                  Request a Demo<i className="fas fa-arrow-right"></i>
                </Link>
              </div>
            </div>
          </div>
          <img src="/assets/images/logos/logo.png" alt="White Circle" style={{
            height: 'auto',
            width: '100px',
            maxHeight: '79px',
            objectFit: 'contain'
          }} />
          <img className="slideUpRight" src="/assets/images/logos/logo.png" alt="Shape" style={{
            height: 'auto',
            width: '100px',
            maxHeight: '79px',
            objectFit: 'contain'
          }} />
          <img className="slideLeftRight" src="/assets/images/logos/logo.png" alt="Shape" style={{
            height: 'auto',
            width: '100px',
            maxHeight: '79px',
            objectFit: 'contain'
          }} />
        </div>
        <div className="row">
          <div className="col-lg-7 col-md-6 mb-4 mb-lg-0">
            <div className="footer-widget about-widget">
              <div className="footer-logo mb-20">
                <Link to="/">
                  <img src="/assets/images/logos/logo.png" alt="Logo" style={{
                    height: 'auto',
                    width: '100px',
                    maxHeight: '79px',
                    objectFit: 'contain'
                  }} />
                </Link>
              </div>
              
            </div>
            <p className="text-justify">
                Acuit CRM is a powerful, self-hosted Customer Relationship Management (CRM) solution designed for small businesses, freelancers, and agencies. It combines CRM, project management, invoicing, and support tools in one integrated platform, helping companies manage clients, projects, and finances more efficiently.
              </p>
              <Link to="/about" className="read-more">Read More <i className="fas fa-arrow-right"></i></Link>
          </div>
          <div className="col-lg-2 col-md-6 mb-4 mb-lg-0">
            <div className="footer-widget link-widget">
              <h4 className="footer-title">About</h4>
              <ul className="list-style-two">
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/features">Features</Link></li>
                <li><Link to="/solutions">Solutions</Link></li>
                <li><Link to="/blog">Blog</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
                <li><Link to="/pricing">Pricing</Link></li>
                <li><Link to="/pitch-tech">Pitch Tech</Link></li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-md-12">
            <div className="footer-widget contact-widget">
              <h4 className="footer-title">Get in Touch</h4>
              <ul className="list-style-three">
                <li>
                  <i className="fas fa-map-marker-alt"></i> 
                  <span>Level 23, NU Tower 2,<br />
                  Jalan Tun Sambanthan, Kuala Lumpur Sentral,<br />
                  50470, Kuala Lumpur, Malaysia</span>
                </li>
                <li>
                  <i className="fas fa-envelope-open"></i> 
                  <span><a href="mailto:mail@plenitudeit.com.my">mail@plenitudeit.com.my</a></span>
                </li>
                <li>
                  <i className="fas fa-phone"></i> 
                  <span>Call : <a href="tel:+60327271889">+603-2727 1889</a></span>
                </li>
              </ul>
              <div className="social-style-one mt-25">
                <a href="https://www.facebook.com/AcuiT-109086621934735" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="https://wa.me/60173936219" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-whatsapp"></i>
                </a>
                <a href="https://www.linkedin.com/company/acuit2022" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="https://www.instagram.com/acuit_crm_solutions/" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="https://twitter.com/acu_it" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-twitter"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright-area text-center">
          <p>© 2022 <a href="https://www.plenitudeit.com.my/" target="_blank" rel="noopener noreferrer">Acu IT owned by Plenitude IT</a> All rights reserved</p>
        </div>
      </div>
      <img className="dots-shape" src="/assets/images/shapes/dots.png" alt="Shape" />
      <img className="tringle-shape" src="/assets/images/shapes/tringle.png" alt="Shape" />
      <img className="close-shape" src="/assets/images/shapes/close.png" alt="Shape" />
      <img className="circle-shape" src="/assets/images/shapes/circle.png" alt="Shape" />
    </footer>
  );
}

export default Footer;

